import React, {useEffect, useState} from 'react'
import {
  checkDemandeAlreadyAssigned,
  editEquipeForDemande,
  postClientDemandeAssign,
} from '../../../../../components/requests'
import {useNavigate} from 'react-router-dom'
import {useAuth} from '../../../../modules/auth'
import {ModeleClientDemande} from '../../../../../components/Models'
import {toast} from 'react-toastify'
import {shouldDisplayFonctionnalite} from '../../../../../components/helpers'
import {ReassignDemandeModal} from '../../ReassignDemandeModal'
import EquipeModal from "../EquipeModal";

const DemandeAssignation = (props) => {
  const {data, setIsAssign, setDemandeClient, demandeClient} = props
  const {currentUser} = useAuth()
  const [loadAssign, setLoadAssign] = useState<boolean>(false)
  const navigate = useNavigate()
  const [users, setUsers] = useState<any[]>([])
  const currentUserCentreIds = (currentUser?.listeCentres?.flat() || []).map((c) => c.id)
  const currentUserPermissionCodes = currentUser?.listeUserPermissions || []
  const [isAssigned, setIsAssigned] = useState<boolean>(false)
  const [selectedEquipe, setSelectedEquipe] = useState<number | null>(null)

  const utilisateursFiltres = users.filter((util) => {
    const utilCentreIds = (util.listeCentres?.flat() || []).map((c) => c.id)
    const utilPermissionCodes = util.listeUserPermissions || []

    const aUnCentreCommun = utilCentreIds.some((id) => currentUserCentreIds.includes(id))
    const aUnePermissionCommune = utilPermissionCodes.some((code) =>
      currentUserPermissionCodes.includes(code)
    )

    return aUnCentreCommun && aUnePermissionCommune
  })

  const handleAssignement = async () => {
    if (!data || !data.client.id || !data.id || !currentUser?.id) return

    setLoadAssign(true)
    try {
      const response = await checkDemandeAlreadyAssigned(data.id)
      const isAssigned = response?.data?.isAssigned
      const assignedUser = response?.data?.assignedUser

      if (isAssigned && assignedUser) {
        setDemandeClient((prev) => {
          if (!prev) return undefined
          return {
            ...prev,
            utilisateurAssigne: assignedUser,
          }
        })
        setIsAssign(false)
        setIsAssigned(false)
        setLoadAssign(false)

        toast.error(
          `Cette demande a déjà été assignée à ${assignedUser.nom} ${assignedUser.prenom}.
          Vous allez être redirigé vers la liste des demandes.`,
          {autoClose: 5000}
        )

        await new Promise((resolve) => setTimeout(resolve, 5000))
        navigate(`/demandes/liste/`)
        return
      }

      const assignResponse = await postClientDemandeAssign(data.client.id, data.id, currentUser.id)
      if (assignResponse.status === 200) {
        setDemandeClient(assignResponse.data)
        setIsAssign(true)
        setIsAssigned(true)
      }
    } catch (error) {
      toast.error("Erreur lors de l'assignation")
    } finally {
      setLoadAssign(false)
    }
  }

  const handleReassign = (demandeId: number, userId: number) => {
    if (data && data.client.id && demandeId && userId) {
      setLoadAssign(true)
      postClientDemandeAssign(data.client.id, data.id, userId)
        .then((response) => {
          if (response.status === 200) {
            setDemandeClient(response.data)
            setIsAssign(true)
            setIsAssigned(true)
            navigate(`/demandes/liste/`)
          } else {
            // Gérer erreur API
            alert('Erreur lors de la réassignation')
          }
          setLoadAssign(false)
        })
        .catch(() => {
          alert('Erreur réseau')
          setLoadAssign(false)
        })
    }
  }

  // Méthode de modification d'une équipe lié à une demande client
  const updateClientDemandeEquipe = () => {
    if (demandeClient && selectedEquipe) {
      editEquipeForDemande(demandeClient?.id, selectedEquipe)
        .then((res) => {
          if (res?.status === 200 && res?.data !== undefined) setDemandeClient(res?.data)
        })
        .catch(() => console.error('Erreur'))
        .finally(() => {
          // Redirection vers la liste après
          // Suppression utilisateur assigné, date assignation, statut sur nouvelle
          navigate(`/demandes/liste/`);
        })
    }
  }

  useEffect(() => {
    if (demandeClient && demandeClient?.utilisateurAssigne != null) {
      setIsAssigned(true)
      setIsAssign(true)
    } else {
      const isAssignAuto = shouldDisplayFonctionnalite(currentUser, 'ASSIGNER AUTOMATIQUEMENT')
      // Verification si l'utilisateur a la fonctionnalité d'assignement automatique
      // Et si l'equipe a été modifier
      if (isAssignAuto && demandeClient?.equipe?.id !== selectedEquipe) {
        handleAssignement()
      }
    }
  }, [demandeClient])

  useEffect(() => {
    if (data) {
      setDemandeClient(data)
      // Définition de l'équipe lié à la demande à traiter
      // Pour pré-selectionner l'équipe dans le modal de changement d'équipe
      if (data?.equipe?.id) setSelectedEquipe(data?.equipe?.id)
    }
  }, [data])

  // useEffect pour modifier l'équipe
  useEffect(() => {
    // Si il y a une équipe selectionnée et si l'équipe est différente de l'ancienne équipe
    if (selectedEquipe && demandeClient?.equipe?.id !== selectedEquipe) {
      updateClientDemandeEquipe()
    }
  }, [selectedEquipe]);

  return (
    <div className='d-flex flex-column gap-2'>
      <div className='d-flex align-items-center gap-6'>
        {demandeClient?.equipe?.nom ?? ''}
        {/* Début modal de changement d'équipe */}
        {(shouldDisplayFonctionnalite(currentUser, 'TRAITER DEMANDE') && (demandeClient?.clientDemandeEtape?.code === "NOUVE" ||
          demandeClient?.clientDemandeEtape?.code === "ASSIG" ||
          demandeClient?.clientDemandeEtape?.code === "MODIF"))
          && (
          <>
            <button
              type='button'
              className='btn btn-light-success btn-sm border border-success'
              data-bs-target='#choixEquipeModal'
              data-bs-toggle='modal'
            >
              Réassigner Autre Équipe
            </button>
            <EquipeModal
              setSelectedEquipe={setSelectedEquipe}
              selectedEquipe={selectedEquipe}
              currentPage={"traitement"}
            />
          </>
        )}
        {/* Fin modal de changement d'équipe */}
        <svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 24 24'>
          <g fill='none'>
            <path
              fill='#e3e0e0'
              fill-opacity='0.16'
              d='M3.2 4h17.6c.66 0 1.2.54 1.2 1.2v12.4c0 1.32-1.08 2.4-2.4 2.4H4.4C3.08 20 2 18.92 2 17.6V5.2C2 4.54 2.54 4 3.2 4'
            />
            <path
              stroke='#e3e0e0'
              stroke-linecap='round'
              stroke-linejoin='round'
              stroke-width='1.5'
              d='m5 7.06l6.87 5.89c.07.06.19.06.26 0L19 7.06M3.2 4h17.6c.66 0 1.2.54 1.2 1.2v12.4c0 1.32-1.08 2.4-2.4 2.4H4.4C3.08 20 2 18.92 2 17.6V5.2C2 4.54 2.54 4 3.2 4'
            />
          </g>
        </svg>
        <div className={'d-flex align-items-center gap-3'}>
          <i className='ki-duotone ki-user fs-2x'>
            <span className='path1'></span>
            <span className='path2'></span>
          </i>
          {!isAssigned && (
            <button
              type='button'
              className='btn btn-primary btn-sm'
              onClick={() => {
                if (shouldDisplayFonctionnalite(currentUser, 'TRAITER DEMANDE') && !shouldDisplayFonctionnalite(currentUser, 'ASSIGNER AUTOMATIQUEMENT'))
                  handleAssignement()
              }}
            >
              {shouldDisplayFonctionnalite(currentUser, 'TRAITER DEMANDE') && shouldDisplayFonctionnalite(currentUser, 'ASSIGNER AUTOMATIQUEMENT')
                ? 'Assignation auto'
                : "Me l'assigner"}
              {loadAssign && (
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              )}
            </button>
          )}
          {loadAssign && isAssigned ? (
            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
          ) : (
            demandeClient?.utilisateurAssigne &&
            demandeClient?.utilisateurAssigne?.prenom + ' ' + demandeClient?.utilisateurAssigne?.nom
          )}
        </div>
        {isAssigned && (
          shouldDisplayFonctionnalite(currentUser, 'TRAITER DEMANDE') && shouldDisplayFonctionnalite(currentUser, 'REASSIGNER DEMANDE')
            || (demandeClient?.utilisateurAssigne?.id == currentUser?.id && shouldDisplayFonctionnalite(currentUser, 'REASSIGNER DEMANDE'))
          ) && !loadAssign && (
            <>
              <button
                type='button'
                className='btn btn-light-warning btn-sm border border-warning'
                data-bs-toggle='modal'
                data-bs-target='#modalReassign'
              >
                Réassigner
              </button>
              <ReassignDemandeModal
                demandeId={demandeClient?.id || 0}
                utilisateurs={utilisateursFiltres}
                onReassign={handleReassign}
                utilisateurAssign={data?.utilisateurAssigne?.id}
                equipe={demandeClient?.equipe?.nom}
              />
            </>
          )}
      </div>
    </div>
  )
}

export default DemandeAssignation
